import { createSlice } from '@reduxjs/toolkit';

const overlaySlice = createSlice({
  name: 'overlay',
  initialState: { overlays: {} },
  reducers: {
    toggleOverlay: (state, action) => {
      state.overlays[action.payload] = !state.overlays[action.payload];
    },
    closeOverlay: (state, action) => {
      state.overlays[action.payload] = false;
    },
    openOverlay: (state, action) => {
      state.overlays[action.payload] = true;
    },
  },
});

export const { toggleOverlay, closeOverlay, openOverlay } =
  overlaySlice.actions;

export default overlaySlice.reducer;
